module.exports = __webpack_public_path__ + "img/Flag.aa5c9e39.svg";